// animate-on-scroll.directive.ts
import { Directive, ElementRef, OnInit, OnDestroy, PLATFORM_ID, Inject, EventEmitter, Output, signal, Input } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[appAnimateOnScroll]',
  standalone: true
})
export class AnimateOnScrollDirective implements OnInit, OnDestroy {
  @Output() isVisible = new EventEmitter<boolean>();
  private observer?: IntersectionObserver;

  @Input() startVisible = false;

  constructor(private el: ElementRef, @Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (!this.startVisible) {
        this.el.nativeElement.classList.add('opacity-0');
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.el.nativeElement.classList.add('animate-in');
              // this.el.nativeElement.classList.remove('opacity-0');
              this.isVisible.emit(true);
              this.observer?.disconnect();
            }
          });
        },
        { threshold: 0.3 } // Se activa cuando el 10% es visible
      );

      this.observer.observe(this.el.nativeElement);
    }
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }
}